import find from 'lodash/find'
import React from 'react'
import type { SelectOption, SelectProps } from '@ztechapps/webui.input'
import { Select } from '@ztechapps/webui.input'
import { CountryList } from '@ztechapps/common.contract'
import map from 'lodash/map'
import type { SingleValue } from 'react-select'

const options: SelectOption[] = map(CountryList, (item) => ({
  value: item?.value,
  label: item?.name,
  iso2: item.iso2,
}))

export const CountrySelect = ({ value, ...rest }: SelectProps) => {
  //we need to get here the actual value object from the Country list
  //when the passed value is and object with {value, name} props, use the field value when searching from the list
  //if value that was passed was string, that is the country code and use that in finding the CountryList
  const _value = React.useMemo(() => {
    //const code = value?.value ?? value
    const singleValue = value as SingleValue<SelectOption>
    const code = singleValue?.value ?? value

    const foundCountry = find(CountryList, (item) => {
      return item?.value === code || item?.iso2 === code
    })

    return find(options, { value: foundCountry?.value })
  }, [value])

  return (
    <Select
      {...{
        value: _value,
        ...rest,
        options,
      }}
    />
  )
}
